import { render, staticRenderFns } from "./WatchOptions.vue?vue&type=template&id=0ed9e4f8&"
import script from "./WatchOptions.vue?vue&type=script&lang=ts&"
export * from "./WatchOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports